import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './priceInfo.css';

interface IPriceInfo {
  price: string;
  priceHistory: React.ReactElement;
  priceInOtherCurrencies: React.ReactElement | null;
  coworkingAdditionalInfo: React.ReactElement | null;
}

export const PriceInfo = ({ price, priceHistory, priceInOtherCurrencies, coworkingAdditionalInfo }: IPriceInfo) => {
  return (
    <div className={styles['price']}>
      <div className={styles['amount']}>
        <UIHeading1>{price}</UIHeading1>
        <div className={styles['coworking-additional-info']}>{coworkingAdditionalInfo}</div>
      </div>
      <div className={styles['history']}>{priceHistory}</div>
      <div className={styles['currencies']}>{priceInOtherCurrencies}</div>
    </div>
  );
};
